var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"blog-journal"},[_c('JournalLanding',{staticClass:"blog-journal__landing",attrs:{"article":_vm.landingArticle}}),_vm._v(" "),_c('ArticleCards',{staticClass:"blog-journal__cards",attrs:{"articles":_vm.blog.articles}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }